import React, { useState, useEffect } from "react";
import "../styles/ProjectFooter.css";

const ProjectFooter = () => {
  const [policyVisible, setPolicyVisible] = useState(false);

  const togglePolicy = () => {
    setPolicyVisible((prevState) => !prevState);
  };

  const closePolicy = () => {
    setPolicyVisible(false);
  };

  // Close on Escape key
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape" && policyVisible) {
        closePolicy();
      }
    };

    if (policyVisible) {
      document.addEventListener("keydown", handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [policyVisible]);

  return (
    <div className="footer-container">
      <div className="visible-footer">
        <p className="contact-info">
          For questions and feedback:{" "}
          <a href="mailto:afrmnk.dev@gmail.com" className="contact-email">
            afrmnk.dev@gmail.com
          </a>
        </p>

        <button
          onClick={togglePolicy}
          className="privacy-policy-button"
          aria-expanded={policyVisible}
          aria-controls="privacy-policy-modal"
        >
          Privacy Policy
        </button>
      </div>

      {policyVisible && (
        <>
          {/* Background Overlay */}
          <div
            className="policy-overlay"
            onClick={closePolicy}
            aria-hidden="true"
          />

          {/* Modal at Bottom */}
          <div
            id="privacy-policy-modal"
            className="policy-modal"
            role="dialog"
            aria-labelledby="policy-title"
            aria-modal="true"
          >
            <div className="policy-modal-header">
              <h3 id="policy-title" className="policy-modal-title">
                Privacy Policy
              </h3>
              <button
                onClick={closePolicy}
                className="policy-close-button"
                aria-label="Close privacy policy"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  aria-hidden="true"
                >
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                </svg>
              </button>
            </div>

            <div className="policy-modal-content">
              <p>
                This app does not collect any personal data. In addition, no
                personal data shared with us over email or other communication
                methods will be given to any third party, under any
                circumstances. Your data will also never be used by us for any
                purpose without specific permission. The app engages in no ad
                targeting, data mining, or other activities that may compromise
                your privacy, and we do not affiliate ourselves with any third
                parties that do so.
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProjectFooter;
